import React, { useEffect } from 'react';
import { FieldProps } from 'formik';
import { ISetting } from '@biolibtech/biolib-js';

interface IProps extends FieldProps {
    setting: ISetting;
}

export default function SliderInput(props: IProps) {
    const { field, form, setting } = props;

    const min = setting.config?.min != null ? Number(setting.config.min) : 0;
    const max = setting.config?.max != null ? Number(setting.config.max) : 100;
    const step = setting.config?.step != null ? Number(setting.config.step) : 1;

    useEffect(() => {
        if (field.value === undefined || field.value === null || field.value === '') {
            const defaultValue = Number(setting.default_value);
            form.setFieldValue(field.name, isNaN(defaultValue) ? min : defaultValue);
        }
    }, []);

    const currentValue: number = field.value !== undefined && field.value !== '' ? Number(field.value) : min;

    return (
        <div className='w-full'>
            <div className='flex items-center space-x-3'>
                <span className='flex-none text-sm text-gray-600 min-w-[3rem] text-center'>{min}</span>
                <input
                    {...field}
                    className='flex-1 w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer slider accent-cyan-700'
                    type='range'
                    min={min}
                    max={max}
                    step={step}
                    value={currentValue}
                    onChange={(e) => {
                        const value = Number(e.target.value);
                        form.setFieldValue(field.name, value);
                    }}
                />
                <span className='flex-none text-sm text-gray-600 min-w-[3rem] text-center'>{max}</span>
            </div>
            <div className='mt-2 text-center'>
                <span className='text-sm text-gray-900'>
                    Current value <b>{currentValue}</b>
                </span>
            </div>
        </div>
    );
}
